<template>
  <div>
    <section role="main" class="empty">
      <div class="container">
        <div class="row icon-tabs">
          <ul class="nav nav-tabs" role="tablist">
            <li class="nav-item">
              <router-link to="/executive" class="nav-link"
                ><img src="/img/icons/executives.png" alt="Executives" />
                Executives</router-link
              >
            </li>
            <li class="nav-item">
              <router-link to="/company" class="nav-link"
                ><img src="/img/icons/companies.png" alt="Companies" />
                Companies</router-link
              >
            </li>
            <li class="nav-item">
              <router-link to="/news" class="nav-link"
                ><img src="/img/icons/deals.png" alt="News" /> News</router-link
              >
            </li>
            <li class="nav-item">
              <router-link to="/deals-transactions" class="nav-link"
                ><img src="/img/icons/deals.png" alt="Deals & Transactions" />
                Deals & Transactions</router-link
              >
            </li>
            <li class="nav-item">
              <router-link to="/listing" class="nav-link active"
                ><img src="/img/book.png" style="height: 23px" />
                Listing</router-link
              >
            </li>
            <!-- <li class="nav-item">
              <router-link to="/commentaries" class="nav-link"
                ><img src="/img/icons/commentaries.png" alt="Commentaries" />
                Commentaries</router-link
              >
            </li> -->
            <li class="nav-item">
              <router-link to="/interesting-bites" class="nav-link"
                ><img
                  src="/img/icons/interesting.png"
                  alt="Interesting Facts"
                />
                Interesting Facts</router-link
              >
            </li>
            <!-- NOTE: Temporary hide the open position tab. -->
            <!-- <li class="nav-item">
              <router-link to="/open-positons-new" class="nav-link"
                ><img src="/img/icons/position.png" alt="Open Position" /> Open
                Positons</router-link
              >
            </li> -->
            <li class="">
              <a
                class="nav-link"
                style="
                  font-weight: bold !important;
                  margin-top: 8px;
                  font-size: 13px;
                  color: #1f3342;
                  margin-left: 290px;
                "
              >
                {{ count }}</a
              >
            </li>
          </ul>
          <div id="sixthmenu" class="tab-content mb-3">
            <div class="container px-0">
              <div class="row">
                <div class="col-lg-8 col-sm-8">
                  <!-- <form class="col-12 form-search form-inline"> -->
                  <input
                    type="text"
                    class="search-query"
                    style="border: 0px none; width: 100%"
                    v-model="searchObj.keyword"
                    v-on:keyup.enter="getList(0)"
                    placeholder="Search..."
                  />
                  <!-- </form> -->
                </div>
                <div class="col-lg-4 col-sm-4 col-6 text-right deals-offcanvas">
                  <button class="menuButton" id="openOffcanvas" v-on:click="openCloseModel()">
                    <div class="filter-title-name">Build My Search</div>
                  </button>
                </div>
              </div>
              <!-- <hr /> -->
            </div>
            <hr />
            <div v-if="showDidYouMean" class="did-you-mean">
              Did you mean: <span class="did-you-mean-prompt">{{ searchedPrompt }}</span>
            </div>            
            <div class="col-12 row mt-4">
              <div
                class="col-lg-4 col-sm-4"
                v-for="(data, index) in list"
                :key="index"
              >
                <div class="rectangle-box">
                  <div class="row" style="height: 115px">
                    <div
                      class="col-lg-3 col-sm-3 col-1 pr-2 text-center"
                      style="cursor: pointer"
                      v-on:click="$router.push('/view-listing/' + data.id)"
                    >
                      <a
                        style="cursor: pointer"
                        v-on:click="$router.push('/view-listing/' + data.id)"
                      >
                        <img
                          :title="
                            data.publication && data.publication.name
                              ? data.publication.name
                              : ''
                          "
                          :src="
                            data.publication &&
                            data.publication.publication_logo
                              ? data.publication.publication_logo
                              : ''
                          "
                          alt=""
                          class="md-img"
                        />
                      </a>
                    </div>
                    <div class="clrb">
                      <a
                        :title="data.name"
                        style="font-size: 12px; cursor: pointer"
                        v-on:click="$router.push('/view-listing/' + data.id)"
                        >{{ $helperService.getText2(data.name, 45) }}</a
                      >
                      <br />
                      <a
                        style="font-size: 12px; cursor: pointer"
                        v-on:click="$router.push('/view-listing/' + data.id)"
                        >{{
                          data.publication && data.publication.name
                            ? data.publication.name
                            : ""
                        }}</a
                      >
                      <br />
                      <a
                        style="color: blue; cursor: pointer; font-size: 12px"
                        v-on:click="openLink(data.source_url)"
                        >Source</a
                      >
                    </div>
                  </div>
                  <div
                    class="col-lg-12 col-sm-12"
                    style="cursor: pointer"
                    v-on:click="$router.push('/view-listing/' + data.id)"
                  >
                    <span class="update-date">{{
                      $helperService.getFormatedDate(data.created_at)
                    }}</span>
                  </div>
                </div>
              </div>

              <!-- <div class="col-lg-5 col-sm-4">
                <canvas
                  id="bar-chart5"
                  width="200"
                  height="200"
                  class="mt-3 ml-3"
                >
                </canvas>
              </div> -->
            </div>
            <ErrorComponent @retry="getList(0)" ref="errorComponent" />
            <div class="row mx-0 mb-4">
              <div class="col-lg-12 mt-5 text-center">
                <div class="page-bottom-pagination text-right">
                  <Pagination
                    @page-change="pageChange"
                    @items-per-page-change="itemsPerPageChange"
                    ref="listPagination"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>

  <!-- Listing Section Filter View start here -->
  <div class="navbar company-offcanvas">
    <div
      :class="
        isOpenModel
          ? 'navbar-collapse offcanvas-collapse open'
          : 'navbar-collapse offcanvas-collapse close'
      "
    >
      <div class="inner-filter-close">
        <div class="row">
          <div class="col-lg-6 col-sm-6 col-6 text-left">
            <h6
              class="mb-0"
              style="font-size: 15px; padding-top: 2px; color: #de4a38"
            >
              Listing
            </h6>
          </div>
          <div class="col-lg-6 col-sm-6 col-6" id="closeOffcanvas">
            <button
              class="navbar-toggler menuButton"
              v-on:click="openCloseModel()"
            >
              <img src="/img/cross.png" width="22" height="22" />
            </button>
          </div>
        </div>
      </div>
      <div class="form-group mb-3 px-3" v-if="selectedFilters.length">
        <div class="selected-filters d-flex flex-wrap mt-2">
          <span
            v-for="(filter, index) in selectedFilters"
            :key="index"
            class="selected-chip"
            style="cursor: pointer"
            @click="removeSelectedFilter(filter)"
          >
            {{ filter.name }} <span style="margin-left: 5px">&times;</span>
          </span>
        </div>
      </div>
      <div class="inner-data">
        <div class="filter-modal">
          <div class="overflowScroll">
            <div id="accordion" class="accordion">
              <div class="card mb-0">
                <!-- List Type -->
                <div
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseOne"
                >
                  <a class="card-title"> List Type </a>
                </div>
                <div id="collapseOne" class="card-body collapse show">
                  <form>
                    <div class="d-flex flex-wrap gap-2">
                      <label
                        v-for="(gender, index) in genders"
                        :key="index"
                        class="btns btn-block"
                        :class="{
                          'btn-danger': searchObj.type.includes(gender),
                          'btn-success active':
                            !searchObj.type.includes(gender),
                        }"
                      >
                        <input
                          type="checkbox"
                          class="d-none"
                          :name="gender"
                          :value="gender"
                          v-model="searchObj.type"
                          autocomplete="off"
                          @change="handleToggle(gender, 'list_type', gender)"
                        />
                        {{ gender }}
                      </label>
                    </div>
                  </form>
                </div>
                <!-- Industry -->
                <div
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseTwo"
                >
                  <a class="card-title"> Industry </a>
                </div>
                <div id="collapseTwo" class="card-body collapse show">
                  <form>
                    <div class="d-flex flex-wrap gap-2">
                      <label
                        v-for="(industry, index) in getDisplayedIndustries()"
                        :key="index"
                        class="btns btn-block"
                        :class="{
                          'btn-danger': searchObj.industry_ids.includes(
                            industry.id
                          ),
                          'btn-success active':
                            !searchObj.industry_ids.includes(industry.id),
                        }"
                      >
                        <input
                          type="checkbox"
                          class="d-none"
                          :name="industry.industry_name"
                          :value="industry.id"
                          v-model="searchObj.industry_ids"
                          autocomplete="off"
                          @change="
                            handleToggle(
                              industry.id,
                              'industry',
                              industry.industry_name
                            )
                          "
                        />
                        {{ industry.industry_name }}
                      </label>
                    </div>
                    <!-- View more Button -->
                    <div class="mt-2 text-right">
                      <span v-if="!showAllIndustries" 
                        @click="handleShowMore"
                        style="cursor: pointer; 
                        font-size: 14px; 
                        color: black; 
                        font-weight: 500;">
                        view more
                      </span>
                    </div>
                  </form>
                </div>
                 <!--sub sector -->
                <div
                  v-if="isShowSubsector"
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseThree"
                >
                  <a class="card-title"> Sub Sector </a>
                </div>
                <div id="collapseThree" class="card-body collapse show">
                  <form>
                    <div class="d-flex flex-wrap gap-2">
                      <label
                        v-for="(subsector, index) in subsectorList"
                        :key="index"
                        class="btns btn-block"
                        :class="{
                          'btn-danger': searchObj.subsector_ids.includes(
                            subsector.id
                          ),
                          'btn-success active':
                            !searchObj.subsector_ids.includes(subsector.id),
                        }"
                      >
                        <input
                          type="checkbox"
                          class="d-none"
                          :name="subsector.industry_name"
                          :value="subsector.id"
                          v-model="searchObj.subsector_ids"
                          autocomplete="off"
                          @change="
                            handleToggle(
                              subsector.id,
                              'subsector',
                              subsector.industry_name
                            )
                          "
                        />
                        {{ subsector.industry_name}}
                      </label>
                    </div>
                  </form>
                </div>
                <!-- Job Function -->
                <div
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  href="#collapseThree"
                >
                  <a class="card-title"> Job Function </a>
                </div>
                <div id="collapseThree" class="card-body collapse show">
                  <form>
                    <div class="d-flex flex-wrap gap-2">
                      <label
                        v-for="(job, index) in jobFunctionList"
                        :key="index"
                        class="btns btn-block"
                        :class="{
                          'btn-danger': searchObj.job_function_ids.includes(
                            job.id
                          ),
                          'btn-success active':
                            !searchObj.job_function_ids.includes(job.id),
                        }"
                      >
                        <input
                          type="checkbox"
                          class="d-none"
                          :name="job.job_function_name"
                          :value="job.id"
                          v-model="searchObj.job_function_ids"
                          autocomplete="off"
                          @change="
                            handleToggle(
                              job.id,
                              'job_function',
                              job.job_function_name
                            )
                          "
                        />
                        {{ job.job_function_name }}
                      </label>
                    </div>
                  </form>
                </div>
                <!-- Location -->
                <div
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseFive"
                >
                  <a class="card-title"> Location </a>
                </div>
                <div id="collapseFive" class="card-body collapse show">
                  <div class="form-group mb-3">
                    <!-- <label class="mb-1" style="font-weight: normal">Search Location</label> -->
                    <multiselect
                      v-model="searchObj.country_ids"
                      :options="countryList"
                      :multiple="true"
                      placeholder="Select"
                      label="country_name"
                      track-by="country_name"
                      value-prop="id"
                      searchable="true"
                      mode="tags"
                      @search-change="searchCountryName($event)"
                      @input="onLocationChange"
                      :show-labels="false"
                    >
                    </multiselect>
                  </div>
                </div>
                <!-- Region -->
                <div
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseSix"
                >
                  <a class="card-title"> Region </a>
                </div>
                <div
                  id="collapseSix"
                  class="card-body collapse show"
                  data-parent="#accordion"
                >
                  <form>
                    <div class="d-flex flex-wrap">
                      <label
                        v-for="(region, index) in regionList"
                        :key="index"
                        class="btns btn-block"
                        :class="{
                          'btn-danger': searchObj.region_ids.includes(
                            region.id
                          ),
                          'btn-success active': !searchObj.region_ids.includes(
                            region.id
                          ),
                        }"
                      >
                        <input
                          type="checkbox"
                          class="d-none"
                          :name="region.region_name"
                          :value="region.id"
                          v-model="searchObj.region_ids"
                          autocomplete="off"
                          @change="
                            handleToggle(
                              region.id,
                              'region_new',
                              region.region_name
                            )
                          "
                        />
                        {{ region.region_name }}
                      </label>
                    </div>
                  </form>
                </div>
                <!---- Year --->
                <div
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseNine"
                >
                  <a class="card-title"> Year </a>
                </div>
                <div id="collapseNine" class="card-body collapse show">
                  <div class="form-group mb-3">
                    <!-- <label class="mb-1" style="font-weight: normal">Select Year</label> -->
                    <Field
                      type="text"
                      name="year"
                      class="form-control"
                      placeholder="Year"
                      v-model="searchObj.curr_year"
                      v-slot="{ field }"
                    >
                      <Datepicker
                        autoApply
                        placeholder="Year"
                        v-bind="field"
                        v-model="searchObj.curr_year"
                        yearPicker
                      />
                    </Field>
                  </div>
                </div>
                <!--  -->
              </div>
            </div>
          </div>
          <hr />
          <div
            class="d-flex justify-content-between align-items-center px-3 posfixed"
          >
            <button
              v-on:click="
                getList(0);
                openCloseModel();
              "
              class="apply-btn mr-2"
            >
              Apply
            </button>
            <button
              v-on:click="
                ClearFilter();
                openCloseModel();
              "
              type="button"
              class="apply-btn"
            >
              Reset
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Chart from "chart.js/auto";
import ErrorComponent from "@/components/ErrorComponent";
import Pagination from "@/components/Pagination";
import Multiselect from "@vueform/multiselect";
import { Field } from "vee-validate";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import moment from "moment";
export default {
  name: "News",
  components: {
    ErrorComponent,
    Pagination,
    Multiselect,
    Field,
    Datepicker,
  },
  data() {
    return {
      id: this.$route.params.id,
      loader: true,
      isShowSubsector: false,
      showAllIndustries: false,
      showDidYouMean: false,
      count: 0,
      genders: ["Company", "Executive"],
      searchObj: {
        from_date: "",
        to_date: "",
        industry_ids: [],
        job_function_ids: [],
        region_ids: [],
        country_ids: [],
        type: [],
        subsector_ids: [],
        countryKeyword: "",
        curr_year: "",
      },
      country_obj: {},
      industryList: [],
      regionList: [],
      jobFunctionList: [],
      bitesMovesPerDay: [],
      countryList: [],
      company_ids: [],
      topicList: [],
      offset: -1,
      list: [],
      subsectorList: [],
      subsectorKeyword: "",
      industryKeyword: "",
      jobFunctionKeyword: "",
      selectedFilters: [],
      isOpenModel: false,
    };
  },
  mounted() {
    this.globelSearchResult();
    this.getList(0);
    this.industrylist();
    this.jobFunctionlist();
    this.getRegionlist();
    this.CountryList();
    // this.getbitesMoveByYear();
  },
  watch: {
    'searchObj.industry_ids'(newVal) {

      if (newVal.length === 1) {
        const selectedIndustryId = newVal[0];
        this.onIndustryChange(selectedIndustryId);
        
      } else {
        this.subsectorList = [];
        this.isShowSubsector = false;
        this.searchObj.subsector_ids = [];
        this.selectedFilters = this.selectedFilters.filter(
        (f) => !(f.type === 'subsector')
      );
      }
    },

     // Scroll hide when Offcanvas open
    isOpenModel(newVal) {
    if (newVal) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }
  }
  
  },
  methods: {
    getDisplayedIndustries() {
      return this.showAllIndustries ? this.industryList : this.industryList.slice(0, 15);
    },
    handleShowMore() {
      this.showAllIndustries = true;
    },
    openCloseModel() {
      this.isOpenModel = !this.isOpenModel;
    },
    removeSelectedFilter(filter) {
      if (filter.type === "job_function") {
        this.searchObj.job_function_ids =
          this.searchObj.job_function_ids.filter((id) => id !== filter.id);
      } else if (filter.type === "list_type") {
        this.searchObj.type = this.searchObj.type.filter(
          (id) => id !== filter.id
        );
      } else if (filter.type === "industry") {
        this.searchObj.industry_ids = this.searchObj.industry_ids.filter(
          (id) => id !== filter.id
        );
      } else if (filter.type === "region") {
        this.searchObj.region_ids = this.searchObj.region_ids.filter(
          (id) => id !== filter.id
        );
      } else if (filter.type === "location") {
        this.searchObj.country_ids = this.searchObj.country_ids.filter(
          (id) => id !== filter.id
        );
      } else if (filter.type === "subsector") {
        this.searchObj.subsector_ids = this.searchObj.subsector_ids.filter(
          (id) => id !== filter.id
        );
      }

      // Later you can handle other types like 'company' etc.

      // This line ensures it's removed visually too
      this.selectedFilters = this.selectedFilters.filter(
        (f) => !(f.id === filter.id && f.type === filter.type)
      );
    },
    globelSearchResult() {
      let filters = this.$shareService.getMapValueAndRemove("global_search_filter");
      if (filters && Object.keys(filters).length > 0) {

        // Did you mean
        this.showDidYouMean = filters.flag;
        this.searchedPrompt = filters.prompt;

        let industryId =
          filters.iid && filters.iid != 0 ? Number(filters.iid) : "";   // Industry
        if (industryId) {
          this.searchObj.industry_ids.push(industryId);
          this.selectedFilters.push({
            id: industryId,
            name: "",
            type: "industry",
          });
         
            let subsectorid =
              filters.ssid && filters.ssid != 0 ? Number(filters.ssid) : "";   // Subsector
            if (subsectorid) {
              this.searchObj.subsector_ids.push(subsectorid);
              this.selectedFilters.push({
                id: subsectorid,
                name: "",
                type: "subsector",
              });  
            }
            this.getSubsectorList(industryId);
        }

        let job_function =
          filters.jid && filters.jid != 0 ? Number(filters.jid) : ""; // Job Function
        if (job_function) {
          this.searchObj.job_function_ids.push(job_function);
          this.selectedFilters.push({
            id: job_function,
            name: "",
            type: "job_function",
          });
        }
        
        let countryId =
          filters.cid && filters.cid != 0 ? Number(filters.cid) : "";   // Location
        if (countryId) {
          this.searchObj.country_ids.push(countryId);
          this.selectedFilters.push({
            id: countryId,
            name: "",
            type: "location",
          });
        }

        let regionid =
          filters.rid && filters.rid != 0 ? Number(filters.rid) : "";   // Region
        if (regionid) {
          this.searchObj.region_ids.push(regionid);
          this.selectedFilters.push({
            id: regionid,
            name: "",
            type: "region",
          });
        }

        let year =
          filters.year && filters.year != 0 ? Number(filters.year) : "";   // Year
        if (year) {
          this.searchObj.curr_year = year;
          // this.selectedFilters.push({
          //   id: year,
          //   name: year,
          //   type: "year",
          // });
        }
        
      }
    },
    onLocationChange(selectedIds) {
      this.selectedFilters = this.selectedFilters.filter(
        (filter) =>
          filter.type !== "location" || selectedIds.includes(filter.id)
      );

      // Add any new ones
      selectedIds.forEach((id) => {
        const exists = this.selectedFilters.some(
          (f) => f.id === id && f.type === "location"
        );
        if (!exists) {
          const country = this.countryList.find((c) => c.id === id);
          if (country) {
            this.selectedFilters.push({
              id: country.id,
              name: country.country_name,
              type: "location",
            });
          }
        }
      });
    },
    handleToggle(id, type, name) {
      const exists = this.selectedFilters.find(
        (item) => item.id === id && item.type === type
      );

      if (!exists) {
        this.selectedFilters.push({
          id: id,
          name: name,
          type: type,
        });
      } else {
        this.selectedFilters = this.selectedFilters.filter(
          (item) => !(item.id === id && item.type === type)
        );
      }
    },
    searchCountryName(e) {
      this.countryKeyword = e;
      this.CountryList();
    },
    getRegionlist() {
      // var obj = {};
      if (this.regionKeyword) {
        this.region_obj.keyword = this.regionKeyword;
      }
      this.$api
        .getAPI({
          _action: "/region/list",
          _body: this.region_obj,
        })
        .then((res) => {
          this.regionList = res;
          if (this.selectedFilters && this.selectedFilters.length > 0) {
            for (var i in this.selectedFilters) {
              for (var j in res) {
                if (
                  res[j].id == this.selectedFilters[i].id &&
                  this.selectedFilters[i].type == "region"
                ) {
                  this.selectedFilters[i].name = res[j].region_name;
                }
              }
            }
          }          
        })
        .catch(() => {});
    },
    CountryList() {
      if (this.countryKeyword) {
        this.country_obj.keyword = this.countryKeyword;
      }
      this.$api
        .getAPI({
          _action: "/country/list",
          _body: this.country_obj,
        })
        .then((res) => {
          this.countryList = res;
          if (this.selectedFilters && this.selectedFilters.length > 0) {
            for (var i in this.selectedFilters) {
              for (var j in res) {
                if (
                  res[j].id == this.selectedFilters[i].id &&
                  this.selectedFilters[i].type == "location"
                ) {
                  this.selectedFilters[i].name = res[j].country_name;
                }
              }
            }
          }
        })
        .catch(() => {});
    },
    searchJobFunctionName(e) {
      this.jobFunctionKeyword = e;
      this.jobFunctionlist();
    },
    getbitesMoveByYear() {
      this.$api
        .getAPI({
          _action: "/bites/moves/year",
        })
        .then((res) => {
          this.bitesMovesPerDay = res;
          this.getGraphBitesMoveByDay();
        })
        .catch(() => {});
    },
    openLink(url) {
      window.open(url);
    },
    getGraphBitesMoveByDay() {
      this.labelsArr = [];
      this.revanueArr = [];

      for (var i = 0; i < this.bitesMovesPerDay.length; i++) {
        var topic_name = this.$helperService.getText2(
          this.bitesMovesPerDay[i].topic_name,
          10
        );
        this.labelsArr.push(topic_name);
        var revanue = this.bitesMovesPerDay[i].count;
        this.revanueArr.push(revanue);
      }
      if (this.sales) {
        this.sales.destroy();
      }
      const ctx = document.getElementById("bar-chart5").getContext("2d");
      this.myChart = new Chart(ctx, {
        type: "pie",
        data: {
          labels: this.labelsArr,
          datasets: [
            {
              data: this.revanueArr,
              backgroundColor: [
                "rgba(255, 99, 132, 1)",
                "rgba(54, 162, 235, 1)",
                "rgba(255, 206, 86, 1)",
                "rgba(75, 192, 192, 1)",
                "rgba(153, 102, 255, 1)",
                "rgba(255, 159, 64, 1)",
              ],
              borderColor: "#87CEEB",
              borderWidth: 0,
            },
          ],
        },
        options: {
          plugins: {
            legend: {
              display: true,
            },
          },
          scales: {
            y: {
              display: false,
            },
            x: {
              display: false,
            },
          },
        },
      });
    },
    searchIndustryName(e) {
      this.industryKeyword = e;
      this.industrylist();
    },
    jobFunctionlist() {
      var obj = {};
      if (this.jobFunctionKeyword) {
        obj.keyword = this.jobFunctionKeyword;
      }
      this.$api
        .getAPI({
          _action: "/job/function/list",
        })
        .then((res) => {
          this.jobFunctionList = res;
          if (this.selectedFilters && this.selectedFilters.length > 0) {
            for (var i in this.selectedFilters) {
              for (var j in res) {
                if (
                  res[j].id == this.selectedFilters[i].id &&
                  this.selectedFilters[i].type == "job_function"
                ) {
                  this.selectedFilters[i].name = res[j].job_function_name;
                }
              }
            }
          }          
        })
        .catch(() => {});
    },
    closesub(e) {
      if (!e) {
        this.searchObj.subsector_ids = [];
      }
    },
    onIndustryChange(selectedIndustryId) {
      if (selectedIndustryId) {
        this.subsectorList = [];
        this.isShowSubsector = false;
        this.getSubsectorList(selectedIndustryId);
      } else {
        this.isShowSubsector = false;
      }
    },
    industrylist() {
      this.$api
        .getAPI({
          _action: "/industry/list",
        })
        .then((res) => {
          this.industryList = res;
          if (this.selectedFilters && this.selectedFilters.length > 0) {
            for (var i in this.selectedFilters) {
              for (var j in res) {
                if (
                  res[j].id == this.selectedFilters[i].id &&
                  this.selectedFilters[i].type == "industry"
                ) {
                  this.selectedFilters[i].name = res[j].industry_name;
                }
              }
            }
          }                    
        })
        .catch(() => {});
    },
    getSubsectorList(id) {
      this.$api
        .getAPI({
          _action: "/subsectors/list/" + id,
        })
        .then((res) => {
          res = res.list;
          this.subsectorList = res;

          // Only show subsector dropdown if there are subsectors(of industry) available
          if (this.subsectorList.length > 0) {
            this.isShowSubsector = true;
          } else {
            this.isShowSubsector = false;
          }

          if (this.selectedFilters && this.selectedFilters.length > 0) {
            for (var i in this.selectedFilters) {
              for (var j in res) {
                if (
                  res[j].id == this.selectedFilters[i].id &&
                  this.selectedFilters[i].type == "subsector"
                ) {
                  this.selectedFilters[i].name = res[j].industry_name;
                }
              }
            }
          }
        })
        .catch(() => {
          this.isShowSubsector = false;
        });
    },
    pageChange(offset) {
      this.getList(offset - 1);
    },
    geteComponydetail(id) {
      if (id) {
        this.$api
          .getAPI({
            _action: "/company/detail/" + id,
          })

          .then((res) => {
            this.searchObj.industry_ids = res.industry_id;
          })
          .catch(() => {});
      }
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
      this.getList(0);
    },
    ClearFilter() {
      this.searchObj = {};
      this.searchObj.type = [];
      this.searchObj.from_date = "";
      this.searchObj.to_date = "";
      this.searchObj.industry_ids = [];
      this.searchObj.region_ids = [];
      this.searchObj.job_function_ids = [];
      this.searchObj.type = [];
      this.searchObj.country_ids = [];
      this.searchObj.subsector_ids = [];
      this.isShowSubsector = false;
      this.searchObj.curr_year = "";
      this.selectedFilters = [];
      this.showDidYouMean = false;
      this.getList(0);
    },
    getList(page) {
      this.$refs.errorComponent.updateListLoader(true);
      this.searchObj.offset = page;
      this.list = [];
      var obj = {};
      obj.offset = this.searchObj.offset;
      if (this.searchObj.from_date) {
        obj.from_date = moment(this.searchObj.from_date).format("DD-MM-YYYY");
      }
      if (this.searchObj.to_date) {
        obj.to_date = moment(this.searchObj.to_date).format("DD-MM-YYYY");
      }
      if (this.searchObj.industry_ids) {
        obj.industry_id = this.searchObj.industry_ids;
      }
      if (this.searchObj.region_ids) {
        obj.region_id = this.searchObj.region_ids;
      }
      if (this.searchObj.subsector_ids) {
        obj.subsector_id = this.searchObj.subsector_ids;
      }
      if (this.searchObj.job_function_ids) {
        obj.job_function_id = this.searchObj.job_function_ids;
      }
      if (this.searchObj.country_ids) {
        obj.country_id = this.searchObj.country_ids;
      }
      if (this.searchObj.type) {
        obj.type = this.searchObj.type;
      }
      if (this.searchObj.curr_year) {
        obj.curr_year = this.searchObj.curr_year;
      }
      this.$api
        .getAPI({
          _action: "/cluster/pagination/list",
          _body: obj,
        })
        .then((res) => {
          this.loader = false;
          this.list = res.list;
          this.count = res.count;
          this.offset = res.next_offset;
          if (page == 0) {
            if (this.$refs.listPagination) {
              if (res.count != null && res.count > 0) {
                this.$refs.listPagination.setTotalCount(res.count);
              } else {
                this.$refs.listPagination.setTotalCount(0);
              }
            }
          }
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(res, "No listing list available");
            this.$refs.errorComponent.updateListLoader(false);
          }
        })
        .catch(() => {
          this.loader = false;
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(0, undefined, "");
            this.$refs.errorComponent.updateListLoader(false);
          }
        });
    },
  },
};
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style scoped>
.multiselect {
  background: #f0f0f0;
  height: 35px;
  border: 1px solid;
}

.multiselect-tag {
  background: #9cc338 !important;
}

[data-toggle="buttons"] > .btns input[type="checkbox"],
[data-toggle="buttons"] > .btn-group > .btns input[type="checkbox"] {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
[type="radio"]:checked,
[type="radio"]:not(:checked) {
  position: relative !important;
  left: 0 !important;
}
label.btns.btn-block.btn-success.active,
label.btns.btn-block.btn-danger {
  border-radius: 15px;
  font-size: 11px;
  color: black;
  margin: 2px;
  padding: 4px 12px;
  font-weight: normal;
  cursor: pointer;
}
label.btns.btn-block.btn-success.active {
  background-color: #e2f0d9;
}
label.btns.btn-block.btn-danger {
  background: #d2ecff;
}
.btn-block {
  display: inline-block;
  width: auto;
}
.card .card-body {
  padding: 2px;
  margin: 0;
}
.input-tags {
  width: 100%;
  padding: 15px;
  display: block;
  margin: 0 auto;
}
.tags-container .tag {
  position: relative;
  padding-right: 24px;
  padding-top: 0.4em;
  padding-bottom: 0.4em;
  padding-left: 0.4em;
  font-size: 85%;
  margin-left: 0.25rem;
}
.card-title {
  font-size: 13px;
}

.selected-chip {
  background-color: #d2ecff; /* light green */
  border-radius: 15px;
  font-size: 12px;
  color: black;
  margin: 2px;
  padding: 10px 20px;
  font-weight: normal;
  cursor: pointer;
}

.remove-icon {
  margin-left: 8px;
  cursor: pointer;
  font-weight: bold;
}
</style>
